
// import React, { useState, useRef, useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { authAPI } from '../../api/auth.api';
// import densityLogo from '../../assets/images/density_logo_new_trans.png';
// import styles from './Navbar.module.css';
// import { searchAll } from '../../api/search/searchApi';

// const Navbar = ({ onMenuToggle, user, isSidebarOpen }) => {
//     const navigate = useNavigate();
//     const [showMobileMenu, setShowMobileMenu] = useState(false);
//     const [searchQuery, setSearchQuery] = useState('');
//     const [searchResults, setSearchResults] = useState([]);
//     const [showSuggestions, setShowSuggestions] = useState(false);
//     const [searchLoading, setSearchLoading] = useState(false);
//     const dropdownRef = useRef(null);
//     const searchRef = useRef(null);

//     // Close mobile menu on outside click
//     useEffect(() => {
//         const handleClickOutside = (event) => {
//             if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
//                 setShowMobileMenu(false);
//             }
//             if (searchRef.current && !searchRef.current.contains(event.target)) {
//                 setShowSuggestions(false);
//             }
//         };
//         document.addEventListener('mousedown', handleClickOutside);
//         return () => document.removeEventListener('mousedown', handleClickOutside);
//     }, []);

//     // Debounced search
//     useEffect(() => {
//         if (!searchQuery.trim()) {
//             setSearchResults([]);
//             setShowSuggestions(false);
//             return;
//         }

//         const timer = setTimeout(async () => {
//             try {
//                 setSearchLoading(true);
//                 console.log('🔍 Searching for:', searchQuery.trim());
//                 const data = await searchAll(searchQuery.trim());
//                 console.log('📊 Full API Response:', data);
//                 console.log('📊 Response type:', typeof data);
//                 console.log('📊 Is array:', Array.isArray(data));
//                 console.log('📊 Response length:', data?.length);
                
//                 if (data && Array.isArray(data)) {
//                     // Log each item to understand structure
//                     data.forEach((item, index) => {
//                         console.log(`Item ${index}:`, item);
//                         console.log(`  - type: ${item.type}`);
//                         console.log(`  - category: ${item.category}`);
//                         console.log(`  - data length: ${item.data?.length}`);
//                     });
//                     setSearchResults(data);
//                     setShowSuggestions(true);
//                 } else {
//                     console.error('❌ Invalid response format:', data);
//                     setSearchResults([]);
//                     setShowSuggestions(false);
//                 }
//             } catch (err) {
//                 console.error('❌ Search error:', err);
//                 setSearchResults([]);
//                 setShowSuggestions(false);
//             } finally {
//                 setSearchLoading(false);
//             }
//         }, 300);

//         return () => clearTimeout(timer);
//     }, [searchQuery]);

//     const handleLogout = async () => {
//         try {
//             await authAPI.logout();
//         } catch (error) {
//             console.error('⚠️ Logout API error:', error);
//         }
//         localStorage.removeItem('auth_token');
//         navigate('/login');
//     };

//     const getInitials = (name) => {
//         if (!name) return 'U';
//         return name.split(' ').map(word => word[0]).join('').toUpperCase().slice(0, 2);
//     };

//     const formatCurrency = (amount) => {
//         if (amount == null || amount === '') return '';
//         const num = parseFloat(amount);
//         if (isNaN(num)) return amount;
//         return '₹' + num.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
//     };

//     const formatDate = (dateVal) => {
//         if (!dateVal) return '';
//         try {
//             const d = new Date(dateVal);
//             if (isNaN(d.getTime())) return String(dateVal);
//             return d.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
//         } catch {
//             return String(dateVal);
//         }
//     };

//     // Group results by category
//     const groupedResults = () => {
//         if (!searchResults || searchResults.length === 0) {
//             console.log('⚠️ No search results to group');
//             return {};
//         }
        
//         console.log('🔄 Grouping results, total items:', searchResults.length);
//         const groups = {};
        
//         for (let i = 0; i < searchResults.length; i++) {
//             const item = searchResults[i];
//             console.log(`Processing item ${i}:`, item);
            
//             if (item.type === 'header') {
//                 console.log(`📌 Found header for category: ${item.category}`);
//                 groups[item.category] = {
//                     header: item,
//                     rows: []
//                 };
//             } else if (item.type === 'data') {
//                 console.log(`📝 Found data row for category: ${item.category}`);
//                 if (groups[item.category]) {
//                     groups[item.category].rows.push(item);
//                     console.log(`   Added to ${item.category}, now has ${groups[item.category].rows.length} rows`);
//                 } else {
//                     console.log(`   ⚠️ No header found for category: ${item.category}`);
//                 }
//             }
//         }
        
//         console.log('✅ Final grouped results:', groups);
//         return groups;
//     };

//     const renderSuggestions = () => {
//         const groups = groupedResults();
//         const categories = Object.keys(groups);
        
//         console.log('🎨 Rendering suggestions, categories found:', categories);
        
//         if (categories.length === 0) {
//             console.log('❌ No categories to render');
//             return null;
//         }

//         return (
//             <div className={styles.searchDropdown}>
//                 {categories.map((category) => {
//                     const { header, rows } = groups[category];
//                     const headers = header.data;
                    
//                     console.log(`📊 Rendering ${category}:`);
//                     console.log(`   Headers:`, headers);
//                     console.log(`   Rows count: ${rows.length}`);
                    
//                     if (rows.length === 0) {
//                         return null;
//                     }

//                     return (
//                         <div key={category} className={styles.searchGroup}>
//                             <div className={styles.searchGroupTitle}>{category} Results</div>
//                             <div className={styles.searchTableWrapper}>
//                                 <table className={styles.searchTable}>
//                                     <thead>
//                                         <tr>
//                                             {headers && headers.map((h, i) => (
//                                                 <th key={i}>{h}</th>
//                                             ))}
//                                         </tr>
//                                     </thead>
//                                     <tbody>
//                                         {rows.map((row, rowIdx) => (
//                                             <tr
//                                                 key={rowIdx}
//                                                 className={styles.searchRow}
//                                                 onClick={() => {
//                                                     // Handle click - navigate to the appropriate page
//                                                     setShowSuggestions(false);
//                                                     setSearchQuery('');
//                                                     const firstValue = row.data[0];
//                                                     if (category === 'Invoice') {
//                                                         navigate(`/invoice/${firstValue}`);
//                                                     } else if (category === 'Order') {
//                                                         navigate(`/order/${firstValue}`);
//                                                     }
//                                                 }}
//                                             >
//                                                 {row.data && row.data.map((cell, cellIdx) => {
//                                                     const headerName = headers[cellIdx]?.toLowerCase() || '';
//                                                     let display = cell;
//                                                     if (headerName.includes('amount') || headerName.includes('total')) {
//                                                         display = formatCurrency(cell);
//                                                     } else if (headerName.includes('date')) {
//                                                         display = formatDate(cell);
//                                                     }
//                                                     return (
//                                                         <td key={cellIdx}>
//                                                             {cellIdx === 0
//                                                                 ? <strong>{display}</strong>
//                                                                 : display || '—'
//                                                             }
//                                                         </td>
//                                                     );
//                                                 })}
//                                             </tr>
//                                         ))}
//                                     </tbody>
//                                 </table>
//                             </div>
//                         </div>
//                     );
//                 })}
//             </div>
//         );
//     };

//     return (
//         <nav className={styles.navbar}>
//             <div className={styles.leftSection}>
//                 <button
//                     className={styles.menuToggle}
//                     onClick={onMenuToggle}
//                     aria-label="Toggle sidebar"
//                 >
//                     {isSidebarOpen ? '✕' : '☰'}
//                 </button>
//                 <div className={styles.logo}>
//                     <img src={densityLogo} alt="Density Logo" className={styles.logoImage} />
//                 </div>
//             </div>

//             {/* ─── Search Bar ─────────────────────────────── */}
//             <div className={styles.searchSection} ref={searchRef}>
//                 <div className={styles.searchInputWrapper}>
//                     <span className={styles.searchIcon}>🔍</span>
//                     <input
//                         type="text"
//                         className={styles.searchInput}
//                         placeholder="Search invoices, orders..."
//                         value={searchQuery}
//                         onChange={(e) => setSearchQuery(e.target.value)}
//                         onFocus={() => {
//                             if (searchResults && searchResults.length > 0) {
//                                 setShowSuggestions(true);
//                             }
//                         }}
//                     />
//                     {searchLoading && (
//                         <span className={styles.searchSpinner} />
//                     )}
//                     {searchQuery && !searchLoading && (
//                         <button
//                             className={styles.searchClear}
//                             onClick={() => {
//                                 setSearchQuery('');
//                                 setSearchResults([]);
//                                 setShowSuggestions(false);
//                             }}
//                         >
//                             ✕
//                         </button>
//                     )}
//                 </div>
//                 {showSuggestions && searchResults && searchResults.length > 0 && renderSuggestions()}
//                 {showSuggestions && !searchLoading && searchResults && searchResults.length === 0 && searchQuery.trim() && (
//                     <div className={styles.searchDropdown}>
//                         <div className={styles.searchNoResults}>No results found</div>
//                     </div>
//                 )}
//             </div>

//             <div className={styles.rightSection}>
//                 {/* Desktop View */}
//                 <div className={styles.userInfoDesktop}>
//                     <div className={styles.userAvatar}>{getInitials(user?.fullName)}</div>
//                     <div className={styles.userDetails}>
//                         <span className={styles.userName}>{user?.fullName || 'User'}</span>
//                         <span className={styles.userEmail}>{user?.email || 'user@example.com'}</span>
//                     </div>
//                 </div>
//                 <button className={styles.logoutBtnDesktop} onClick={handleLogout}>
//                     Logout
//                 </button>

//                 {/* Mobile View */}
//                 <div className={styles.mobileUserContainer} ref={dropdownRef}>
//                     <div
//                         className={styles.userAvatarMobile}
//                         onClick={() => setShowMobileMenu(!showMobileMenu)}
//                         aria-label="User menu"
//                     >
//                         {getInitials(user?.fullName)}
//                     </div>
//                     {showMobileMenu && (
//                         <div className={styles.mobileDropdown}>
//                             <div className={styles.mobileUserInfo}>
//                                 <div className={styles.mobileUserName}>{user?.fullName || 'User'}</div>
//                                 <div className={styles.mobileUserEmail}>{user?.email || 'user@example.com'}</div>
//                             </div>
//                             <button className={styles.mobileLogoutBtn} onClick={handleLogout}>
//                                 Logout
//                             </button>
//                         </div>
//                     )}
//                 </div>
//             </div>
//         </nav>
//     );
// };

// export default Navbar;

import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { authAPI } from '../../api/auth.api';
import { searchAll, getLineItems } from '../../api/search/searchApi';
import densityLogo from '../../assets/images/density_logo_new_trans.png';
import styles from './Navbar.module.css';

const Navbar = ({ onMenuToggle, user, isSidebarOpen }) => {
    const navigate = useNavigate();

    // ─── State ────────────────────────────────────────────────
    const [showMobileMenu, setShowMobileMenu]       = useState(false);
    const [searchQuery, setSearchQuery]             = useState('');
    const [searchResults, setSearchResults]         = useState([]);
    const [showSuggestions, setShowSuggestions]     = useState(false);
    const [searchLoading, setSearchLoading]         = useState(false);

    // Modal state
    const [showModal, setShowModal]                 = useState(false);
    const [modalTitle, setModalTitle]               = useState('');
    const [lineItems, setLineItems]                 = useState([]);
    const [lineItemsLoading, setLineItemsLoading]   = useState(false);

    const dropdownRef = useRef(null);
    const searchRef   = useRef(null);

    // ─── Outside click ────────────────────────────────────────
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setShowMobileMenu(false);
            }
            if (searchRef.current && !searchRef.current.contains(event.target)) {
                setShowSuggestions(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    // ─── Debounced search ─────────────────────────────────────
    useEffect(() => {
        if (!searchQuery.trim()) {
            setSearchResults([]);
            setShowSuggestions(false);
            return;
        }

        const timer = setTimeout(async () => {
            try {
                setSearchLoading(true);
                const data = await searchAll(searchQuery.trim());
                setSearchResults(data || []);
                setShowSuggestions(true);
            } catch (err) {
                console.error('Search error:', err);
                setSearchResults([]);
                setShowSuggestions(false);
            } finally {
                setSearchLoading(false);
            }
        }, 300);

        return () => clearTimeout(timer);
    }, [searchQuery]);

    // ─── Row click → open modal ───────────────────────────────
    const handleRowClick = async (docNum, category) => {
        console.log('🖱️ Row clicked - DocNum:', docNum, '| Category:', category);
        setShowSuggestions(false);
        setModalTitle(`${category} #${docNum} — Line Items`);
        setLineItems([]);
        setShowModal(true);
        setLineItemsLoading(true);

        try {
            const data = await getLineItems(String(docNum), category);
            setLineItems(data || []);
        } catch (err) {
            console.error('Line items error:', err);
            setLineItems([]);
        } finally {
            setLineItemsLoading(false);
        }
    };

    // ─── Helpers ──────────────────────────────────────────────
    const handleLogout = async () => {
        try { await authAPI.logout(); } catch (e) { console.error(e); }
        localStorage.removeItem('auth_token');
        navigate('/login');
    };

    const getInitials = (name) => {
        if (!name) return 'U';
        return name.split(' ').map(w => w[0]).join('').toUpperCase().slice(0, 2);
    };

    const formatCurrency = (amount) => {
        if (amount == null || amount === '') return '';
        const num = parseFloat(amount);
        if (isNaN(num)) return String(amount);
        return '₹' + num.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    };

    const formatDate = (dateVal) => {
        if (!dateVal) return '';
        try {
            const d = new Date(dateVal);
            if (isNaN(d.getTime())) return String(dateVal);
            return d.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
        } catch { return String(dateVal); }
    };

    const formatCell = (cell, headerName) => {
        const h = headerName?.toLowerCase() || '';
        if ((h.includes('amount') || h.includes('total') || h.includes('value')) && !isNaN(parseFloat(cell))) {
            return formatCurrency(cell);
        }
        if (h.includes('date') && cell) {
            return formatDate(cell);
        }
        return cell || '—';
    };

    // ─── Group search results ─────────────────────────────────
    const groupResults = () => {
        const groups = {};
        let currentCategory = null;
        for (const item of searchResults) {
            if (item.type === 'header') {
                currentCategory = item.category;
                groups[currentCategory] = { header: item, rows: [] };
            } else if (item.type === 'data' && currentCategory) {
                groups[currentCategory].rows.push(item);
            }
        }
        return groups;
    };

    // ─── Group modal line items ───────────────────────────────
    const groupLineItems = () => {
        let header = null;
        const rows = [];
        for (const item of lineItems) {
            if (item.type === 'header') header = item;
            else if (item.type === 'data') rows.push(item);
        }
        return { header, rows };
    };

    // ─── Render search dropdown ───────────────────────────────
    const renderSuggestions = () => {
        const groups = groupResults();
        const categories = Object.keys(groups);
        if (categories.length === 0) return null;

        return (
            <div className={styles.searchDropdown}>
                {categories.map((category) => {
                    const { header, rows } = groups[category];
                    const headers = header.data;
                    if (rows.length === 0) return null;

                    return (
                        <div key={category} className={styles.searchGroup}>
                            <div className={styles.searchGroupTitle}>{category} Results</div>
                            <div className={styles.searchTableWrapper}>
                                <table className={styles.searchTable}>
                                    <thead>
                                        <tr>
                                            {headers.map((h, i) => <th key={i}>{h}</th>)}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {rows.map((row, rowIdx) => (
                                            <tr
                                                key={rowIdx}
                                                className={styles.searchRow}
                                                onClick={() => handleRowClick(row.data[0], category)}
                                            >
                                                {row.data.map((cell, cellIdx) => (
                                                    <td key={cellIdx}>
                                                        {cellIdx === 0
                                                            ? <strong>{cell}</strong>
                                                            : formatCell(cell, headers[cellIdx])
                                                        }
                                                    </td>
                                                ))}
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    );
                })}
            </div>
        );
    };

    // ─── Render modal line items table ────────────────────────
    const renderModalContent = () => {
        if (lineItemsLoading) {
            return (
                <div className={styles.modalLoading}>
                    <span className={styles.modalSpinner} />
                    <span>Loading line items...</span>
                </div>
            );
        }

        const { header, rows } = groupLineItems();

        if (!header || rows.length === 0) {
            return <div className={styles.modalEmpty}>No line items found.</div>;
        }

        const headers = header.data;

        return (
            <div className={styles.modalTableWrapper}>
                <table className={styles.modalTable}>
                    <thead>
                        <tr>
                            {headers.map((h, i) => <th key={i}>{h}</th>)}
                        </tr>
                    </thead>
                    <tbody>
                        {rows.map((row, rowIdx) => (
                            <tr key={rowIdx}>
                                {row.data.map((cell, cellIdx) => (
                                    <td key={cellIdx}>
                                        {formatCell(cell, headers[cellIdx])}
                                    </td>
                                ))}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        );
    };

    // ─── Render ───────────────────────────────────────────────
    return (
        <>
        <nav className={styles.navbar}>
            {/* Left */}
            <div className={styles.leftSection}>
                <button className={styles.menuToggle} onClick={onMenuToggle} aria-label="Toggle sidebar">
                    {isSidebarOpen ? '✕' : '☰'}
                </button>
                <div className={styles.logo}>
                    <img src={densityLogo} alt="Density Logo" className={styles.logoImage} />
                </div>
            </div>

            {/* Search */}
            <div className={styles.searchSection} ref={searchRef}>
                <div className={styles.searchInputWrapper}>
                    <span className={styles.searchIcon}>🔍</span>
                    <input
                        type="text"
                        className={styles.searchInput}
                        placeholder="Search invoices, orders..."
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                        onFocus={() => {
                            if (searchResults.length > 0) setShowSuggestions(true);
                        }}
                    />
                    {searchLoading && <span className={styles.searchSpinner} />}
                    {searchQuery && !searchLoading && (
                        <button
                            className={styles.searchClear}
                            onClick={() => {
                                setSearchQuery('');
                                setSearchResults([]);
                                setShowSuggestions(false);
                            }}
                        >✕</button>
                    )}
                </div>

                {showSuggestions && searchResults.length > 0 && renderSuggestions()}

                {showSuggestions && !searchLoading && searchResults.length === 0 && searchQuery.trim() && (
                    <div className={styles.searchDropdown}>
                        <div className={styles.searchNoResults}>No results found</div>
                    </div>
                )}
            </div>

            {/* Right */}
            <div className={styles.rightSection}>
                <div className={styles.userInfoDesktop}>
                    <div className={styles.userAvatar}>{getInitials(user?.fullName)}</div>
                    <div className={styles.userDetails}>
                        <span className={styles.userName}>{user?.fullName || 'User'}</span>
                        <span className={styles.userEmail}>{user?.email || 'user@example.com'}</span>
                    </div>
                </div>
                <button className={styles.logoutBtnDesktop} onClick={handleLogout}>Logout</button>

                <div className={styles.mobileUserContainer} ref={dropdownRef}>
                    <div
                        className={styles.userAvatarMobile}
                        onClick={() => setShowMobileMenu(!showMobileMenu)}
                    >
                        {getInitials(user?.fullName)}
                    </div>
                    {showMobileMenu && (
                        <div className={styles.mobileDropdown}>
                            <div className={styles.mobileUserInfo}>
                                <div className={styles.mobileUserName}>{user?.fullName || 'User'}</div>
                                <div className={styles.mobileUserEmail}>{user?.email || 'user@example.com'}</div>
                            </div>
                            <button className={styles.mobileLogoutBtn} onClick={handleLogout}>Logout</button>
                        </div>
                    )}
                </div>

                {!showMobileMenu && (
                    <button className={styles.logoutBtnMobile} onClick={handleLogout}>Logout</button>
                )}
            </div>
        </nav>

        {/* ─── Modal ──────────────────────────────────────────── */}
        {showModal && (
            <div className={styles.modalOverlay} onClick={(e) => {
                if (e.target === e.currentTarget) setShowModal(false);
            }}>
                <div className={styles.modal}>
                    <div className={styles.modalHeader}>
                        <h3 className={styles.modalTitle}>{modalTitle}</h3>
                        <button className={styles.modalClose} onClick={() => setShowModal(false)}>✕</button>
                    </div>
                    <div className={styles.modalBody}>
                        {renderModalContent()}
                    </div>
                    <div className={styles.modalFooter}>
                        <button className={styles.modalCloseBtn} onClick={() => setShowModal(false)}>
                            Close
                        </button>
                    </div>
                </div>
            </div>
        )}
        </>
    );
};

export default Navbar;